import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { SaveAlumniDetaisService } from '../../@services/alumni-application.service'
import { AlertService } from './../../../../src/app/@services/alert.service';
import { CampusList } from '../../@models/alumani-campusList.models'
import * as _ from 'underscore';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';
import { OverwriteEntryConfirmationModalComponent } from './confirmation-model/confirmation-model.component';
import { Employement } from '../../@models/alumni-application.models';
import { StateList } from '../../@models/alumni-stateList.model';
import { DegreeList } from '../../@models/alumni-degreeList.model';
import { interval as observableInterval } from "rxjs";
import { takeWhile, scan, tap } from "rxjs/operators";
import { CityList } from '../../@models/alumni-cityList.model';
import { WhereDoYouWorkList } from '../../@models/alumni-wheredoyouworkList.component';
import { WhatIsYourSpecialtyList } from '../../@models/alumni-whatisyourspecialty.models';
import { SafeHtml, DomSanitizer } from '@angular/platform-browser';


@Component({
  selector: 'app-alumni-application',
  templateUrl: './alumni-application.component.html',
  styleUrls: ['./alumni-application.component.scss'],
  providers: [DatePipe]
})

export class AlumniApplicationComponent implements OnInit {

  emailPattern = "^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$";
  spacePattern = "^[a-zA-Z0-9]*$";

  flag: boolean = false;

  AlumniID: number = 0;
  Campus: any;
  wcuDegree: any;
  GraduationDateMonth: any;
  GraduationDateYear: any;
  Container: any;

  depCount: number;
  removeAddtionalEducationInfo: Function;
  selectedPrecepted: boolean = false;
  public campusList: Array<CampusList> = [];
  public stateList: Array<StateList> = [];
  public cityList: Array<CityList> = [];
  public whereDoYouWorkListdata: Array<WhereDoYouWorkList> = [];
  public whereDoYouWorkList: Array<WhereDoYouWorkList> = [];
  public WhatIsYourSpecialtyListdata: Array<WhatIsYourSpecialtyList> = [];
  public WhatIsYourSpecialtyList: Array<WhatIsYourSpecialtyList> = [];
  public degreeList: Array<DegreeList> = [];
  employement: Employement[] = [];
  public dategraduatedYearList = [];
  public dategraduatedMonthList = [];
  public validActurecareMonth: boolean = true;

  constructor(private saveAlumniDetaisService: SaveAlumniDetaisService,
    public fb: FormBuilder, public datepipe: DatePipe,
    private _sanitizer: DomSanitizer,
    private alertService: AlertService, private router: Router, public modalService: NgbModal) { }

  selecteddepartment = [];
  CurrentlyWork = [];
  WhatIsSpecialty = [];
  WhatDepartmentdoyouworkin = [];
  savecurrid: any;
  City = [];
  State = [];
  Specialty_Dep = [];
  Department_WorkYear = [];
  Department_WorkMonth = [];
  validDepartment_WorkMonth = [];
  validWhereDoYouCurrentlyWork = [];
  AddCurrWork = [];
  precepted: any;
  preceptedyes: any;
  training_certification: any;
  HaveYouObtainedClearanceFromYourSupervisorToPrecept: any;
  tmpEmployementInfocount = [];
  AcutecareYear: any;
  AcutecareMonth: any;
  maxDate: Date = new Date();

  public defaultcurrentlywork: { ID: number, Site: string } = { ID: 0, Site: "Please Select Currently Work" };
  public defaultdepartment: { ID: number, Department: string } = { ID: 0, Department: "Please Select Speciality/Department" };

  ngOnInit() {
    this.State[0] = "California";
    this.validDepartment_WorkMonth[0] = true;
    this.validWhereDoYouCurrentlyWork[0] = true;
    this.getCampusList();
    this.getStateList();
    this.getCityList(0);
    this.getWhereDoYouWorkList();
    this.getWhatIsYourSpecialtyList();
    this.getDegreeList();
    this.getGraduatedDateYearList();
    this.getGraduatedDateMonthList();
    this.removeAddtionalEducationInfo = this.removeEmployementInfo.bind(this);
    this.depCount = 1;
    this.tmpEmployementInfocount.push(1);
    this.Campus = 0;
    this.wcuDegree = 0;
    this.GraduationDateMonth = 0;
    this.GraduationDateYear = 0;
  }

  public filterworkChange(filter: any): void {
    this.whereDoYouWorkList = this.whereDoYouWorkListdata.filter((s) => s.Site.toLowerCase().indexOf(filter.toLowerCase()) !== -1);
  }

  public filterdepartmentChange(filter: any): void {
    this.WhatIsYourSpecialtyList = this.WhatIsYourSpecialtyListdata.filter((s) => s.Department.toLowerCase().indexOf(filter.toLowerCase()) !== -1);
  }

  StateListFormatter = (data: any): SafeHtml => {
    let html = `<span>${data.StateName}</span>`;
    return this._sanitizer.bypassSecurityTrustHtml(html);
  }

  cityListFormatter = (data: any): SafeHtml => {
    let html = `<span>${data.CityName}</span>`;
    return this._sanitizer.bypassSecurityTrustHtml(html);
  }

  scrollToTop(el) {
    const duration = 600;
    const interval = 5;
    const move = el.scrollTop * interval / duration;

    observableInterval(interval).pipe(
      scan((acc, curr) => acc - move, el.scrollTop),
      tap(position => el.scrollTop = position),
      takeWhile(val => val > 0)).subscribe();
  }

  getCampusList() {
    this.saveAlumniDetaisService.getCampusList()
      .subscribe(result => {
        this.campusList = result.WCUCampusList;
      })
  }

  getStateList() {
    this.saveAlumniDetaisService.getStateList()
      .subscribe(result => {
        this.stateList = result.StateList;
      });
  }

  getWhereDoYouWorkList() {
    this.saveAlumniDetaisService.getWhereDoYouWorkList()
      .subscribe(result => {
        this.whereDoYouWorkList = result.SitesList;
        this.whereDoYouWorkListdata = result.SitesList;
        this.whereDoYouWorkList.splice(0, 0, { ID: 1, Site: "If not listed please enter information here" });
      })
  }

  getWhatIsYourSpecialtyList() {
    this.saveAlumniDetaisService.getWhatIsYourSpecialtyList()
      .subscribe(result => {
        this.WhatIsYourSpecialtyList = result.DepartmentList;
        this.WhatIsYourSpecialtyListdata = result.DepartmentList;
      })
  }

  StatevalueChange(data) {
    if (typeof (data) != 'string') {
      var value = data.StateCode;
      this.saveAlumniDetaisService.getCityList({ 'StateCode': value })
        .subscribe(result => {
          this.cityList = result.CityList;
        });
    }
  }

  getCityList(i) {
    var stateCode = this.State[i] == undefined ? "" : this.State[i];
    if (stateCode == 'California') {
      stateCode = 'CA';
    }
    this.saveAlumniDetaisService.getCityList({ 'StateCode': stateCode })
      .subscribe(result => {
        this.cityList = result.CityList;
      });
  }

  getDegreeList() {
    this.saveAlumniDetaisService.getDegreeList()
      .subscribe(result => {
        this.degreeList = result.DegreeList;
      })
  }

  getGraduatedDateYearList() {
    this.saveAlumniDetaisService.getYearListForGraduatedDate()
      .subscribe(result => {
        this.dategraduatedYearList = result.Years;
      })
  }

  getGraduatedDateMonthList() {
    this.saveAlumniDetaisService.getMonthListForGraduatedDate()
      .subscribe(result => {
        this.dategraduatedMonthList = result.Months;
      })
  }

  Campuschange(data) {
    if (data.Alumni_CampusID == 0) {
      this.Campus = 0;
    }
  }

  Degreechange(data) {
    if (data.AdProgramID == 0) {
      this.wcuDegree = 0;
    }
  }

  CurrentlyWorkchange(data, i) {
    if (data == 0) {
      this.CurrentlyWork[i] = 0;
      this.validWhereDoYouCurrentlyWork[i] = false;
    } else {
      this.validWhereDoYouCurrentlyWork[i] = true;
    }
  }

  WhatIsYourSpecialtychange(data, i) {
    if (data == 0) {
      this.Specialty_Dep[i] = 0;
    }
  }

  selectedprecepted() {
    if (this.precepted == 'Yes') {
      this.selectedPrecepted = true;
    } else {
      this.selectedPrecepted = false;
    }
  }

  addEmployementInfo() {
    this.depCount += 1;
    this.State[this.depCount - 1] = "California";
    this.validDepartment_WorkMonth[this.depCount - 1] = true;
    this.validWhereDoYouCurrentlyWork[this.depCount - 1] = true;
    this.tmpEmployementInfocount.push(this.depCount);
    this.depCount = this.depCount > 4 ? this.depCount : this.depCount;
    return this.depCount;
  }

  removeEmployementInfo() {
    this.depCount -= 1;
    this.tmpEmployementInfocount.push(this.depCount);
    this.selecteddepartment.splice(this.depCount, 1);
    this.CurrentlyWork.splice(this.depCount, 1);
    this.City.splice(this.depCount, 1);
    this.State.splice(this.depCount, 1);
    this.WhatIsSpecialty.splice(this.depCount, 1);
    this.WhatDepartmentdoyouworkin.splice(this.depCount, 1);
    this.Department_WorkYear.splice(this.depCount, 1);
    this.Department_WorkMonth.splice(this.depCount, 1);
    this.depCount = this.depCount < 1 ? 1 : this.depCount;
  }

  removeEmploymentInfoparticular(data) {
    if (this.depCount > 1) {
      this.depCount -= data;
      this.tmpEmployementInfocount.splice(data, 1);
      this.selecteddepartment.splice(data, 1);
      this.CurrentlyWork.splice(data, 1);
      this.City.splice(data, 1);
      this.State.splice(data, 1);
      this.WhatIsSpecialty.splice(data, 1);
      this.WhatDepartmentdoyouworkin.splice(data, 1);
      this.Department_WorkYear.splice(data, 1);
      this.Department_WorkMonth.splice(data, 1);
      this.depCount = this.tmpEmployementInfocount.length < 1 ? 1 : this.tmpEmployementInfocount.length;
    }
  }

  private getDisableColor(sourceControl) {
    if (sourceControl === 'ADDEMPINFO') {
      if (this.depCount !== this.depCount) {
        return '#e9ecef';
      } else {
        return '';
      }
    } else if (sourceControl === 'REMOVEEMPINFO') {
      if (this.depCount === 1) {
        return '#e9ecef';
      } else {
        return '';
      }
    } else {
      return '';
    }
  }

  WorkInDepartmentyouYear(data, i) {
    if (data <= 365) {
      data = data.replace('years', '').replace('year', '').trim();
      if (data != "") {
        if (parseInt(data) >= 2)
          this.Department_WorkYear[i] = data + " years";
        else
          this.Department_WorkYear[i] = data + " year";
      }
    } else {
      this.Department_WorkYear[i] = null;
    }
  }

  WorkInDepartmentyouMonth(data, i) {
    data = data.replace('months', '').replace('month', '').trim();
    if (data <= 12) {
      this.validDepartment_WorkMonth[i] = true;
    } else {
      this.validDepartment_WorkMonth[i] = false;
      // this.Department_WorkMonth[i] = null;
    }

    if (data != "") {
      if (parseInt(data) >= 2)
        this.Department_WorkMonth[i] = data + " months";
      else
        this.Department_WorkMonth[i] = data + " month";
    }
  }

  AcutecareYearChange(data) {
    if (data <= 365) {
      data = data.replace('years', '').replace('year', '').trim();
      if (data != "") {
        if (parseInt(data) >= 2) {
          this.AcutecareYear = data + " years";
        }
        else {
          this.AcutecareYear = data + " year";
        }
      }
    } else {
      this.AcutecareYear = null;
    }
  }

  AcutecareMonthChange(data, model) {
    data = data.replace('months', '').replace('month', '').trim();
    if (data <= 12) {
      this.validActurecareMonth = true;
    } else {
      this.validActurecareMonth = false;
      // this.AcutecareMonth = null;
    }
    // data = data.replace('months', '').replace('month', '').trim();
    if (data != "") {
      if (parseInt(data) >= 2)
        this.AcutecareMonth = data + " months";
      else
        this.AcutecareMonth = data + " month";
    }
  }

  SaveAlumaniDetails(data, container) {
    this.AlumniID = 0;
    this.Container = container;
    if (data.FirstName == undefined || data.FirstName == "" || data.FirstName == " " || data.LastName == undefined || data.LastName == "" ||
      data.LastName == " " || data.EmailAddress == undefined || data.EmailAddress == "" || this.GraduationDateYear == undefined || this.GraduationDateYear == "" ||
      this.GraduationDateMonth == undefined || this.GraduationDateMonth == "" || data.LastName == " " || (data.precepted == "Yes" && this.preceptedyes == undefined) ||
      this.Campus == undefined || this.Campus == null || this.Campus == 0 || this.wcuDegree == undefined || this.wcuDegree == null || this.wcuDegree == 0) {
      this.scrollToTop(container);
      return;
    } else {
      var acutecaremonth = this.AcutecareMonth == undefined ? "" : this.AcutecareMonth;
      var checkActureCare = acutecaremonth.replace('months', '').replace('month', '').trim();
      if (checkActureCare != "") {
        if (parseInt(checkActureCare) > 12) {
          this.validActurecareMonth = false;
          var div = document.getElementById("divacturemonth");
          div.scrollIntoView();
          return;
        }
        else {
          this.validActurecareMonth = true;
        }
      }
      for (var i = 0; i < this.depCount; i++) {
        var currentrymonth = this.Department_WorkMonth[i] == undefined ? "" : this.Department_WorkMonth[i];
        var checkdepartmentmonth = currentrymonth.replace('months', '').replace('month', '').trim();
        if (checkdepartmentmonth != "") {
          if (parseInt(checkdepartmentmonth) > 12) {
            this.validDepartment_WorkMonth[i] = false;
            var div = document.getElementById("divdepartmentmonth" + i);
            div.scrollIntoView();
            return;
          }
          else {
            this.validDepartment_WorkMonth[i] = true;
          }
        }
        if (this.State[i] == "" || this.State[i] == undefined || this.City[i] == "" || this.City[i] == undefined || (this.CurrentlyWork[i] == undefined || this.CurrentlyWork[i].ID == 0) ||
          (this.CurrentlyWork[i] != undefined && (this.CurrentlyWork[i].ID == 1 && (this.AddCurrWork[i] == undefined || this.AddCurrWork[i] == "")))) {
          var div = document.getElementById("divState" + i);
          div.scrollIntoView();
          return;
        } else {
          var currwork = this.CurrentlyWork[i];
          var addcurrwork = this.AddCurrWork[i];
          if (currwork != undefined && currwork != "") {
            if (currwork.ID == 1 && addcurrwork != "") {
              this.saveAlumniDetaisService.SaveCurrentlyWork({ 'Site': addcurrwork }).subscribe((res) => {
                if (res.ServiceStatus == 'SUCCESS') {
                  this.savecurrid = res.Result;
                  this.getWhereDoYouWorkList();
                  var data: { ID: number, Site: string } = { ID: res.Result, Site: addcurrwork.toString() };
                  this.CurrentlyWork[i - 1] = data;
                } else {
                  this.savecurrid = 0;
                  this.alertService.setAlert(this.alertService.TYPE.DANGER, res.Message);
                  this.scrollToTop(this.Container);
                  return;
                }
              });
            } else {
            }
          }
        }
      }
    }
    this.saveAlumniDetaisService.checkEmail(data.EmailAddress.trim()).subscribe((result) => {
      if (result.ServiceStatus === 'SUCCESS') {
        if (result.Result != 0) {
          this.saveAlumniDetaisService.getAlumniDuplicateList(data.EmailAddress.trim()).subscribe(x => {
            if (x.ServiceStatus == "SUCCESS") {
              x.AlumniList.map((res) => {
                res.GraduatedDate = this.datepipe.transform(res.GraduatedDate, 'MM-dd-yyyy');
                res.ISActive = res.ISActive == 1 ? 'true' : 'false';
              });

              const activeModel = this.modalService.open(OverwriteEntryConfirmationModalComponent, { container: '#sideNav' });
              activeModel.componentInstance.modalHeader =
                'Hey welcome back! We have your below details with us . Do you want to update it?';
              activeModel.componentInstance.modaldata = x.AlumniList;
              activeModel.result.then((diaresult) => {
                this.AlumniID = result.Result;
                this.SaveAlumniData(data);
              }, (dismiss) => {
                if (dismiss != 'close' && dismiss != 0) {
                  localStorage.setItem('duplicateemail', JSON.stringify({ email: data.EmailAddress }));
                  this.SaveAlumniData(data);
                }
              });
            }
          });
        } else if (result.Result == 0) {
          this.SaveAlumniData(data);
        } else {
          this.alertService.setAlert(this.alertService.TYPE.DANGER, result.Message);
        }
      }
    }, err => {
      this.alertService.setAlert(this.alertService.TYPE.DANGER, 'FAIL');
    });
  }

  SaveAlumniData(data) {
    this.employement = [];
    for (var i = 0; i < this.depCount; i++) {
      if ((this.CurrentlyWork[i] == "" || this.CurrentlyWork[i] == 0) && (this.City[i] == "" || this.City[i] == undefined) &&
        (this.State[i] == "" || this.State[i] == undefined) && (this.WhatIsSpecialty[i] == "" || this.WhatIsSpecialty[i] == undefined)
        && (this.WhatDepartmentdoyouworkin[i] == "" || this.WhatDepartmentdoyouworkin[i] == undefined)
        && (this.Department_WorkYear[i] == "" || this.Department_WorkYear[i] == undefined) &&
        (this.Department_WorkMonth[i] == "" || this.Department_WorkMonth[i] == undefined) &&
        (this.selecteddepartment[i] == "" || this.selecteddepartment[i] == undefined)) {

      } else {
        var currentryyear = this.Department_WorkYear[i] == undefined ? "" : this.Department_WorkYear[i];
        var currentrymonth = this.Department_WorkMonth[i] == undefined ? "" : this.Department_WorkMonth[i];
        var city = this.City[i] == undefined ? "" : this.City[i];

        if (typeof (city) == 'string') {
          city = city;
        } else {
          city = city["CityName"];
        }

        var state = this.State[i];
        if (typeof (state) == 'string') {
          state = state;
        } else {
          state = state["StateName"];
        }

        const tmpdata = {
          CurrentlyWork: this.CurrentlyWork[i] == 0 || this.CurrentlyWork[i] == undefined ? "" : this.CurrentlyWork[i]["ID"],
          CurrentlyWorkValue: this.CurrentlyWork[i] == 0 || this.CurrentlyWork[i] == undefined ? "" : this.CurrentlyWork[i]["Site"],
          City: city == undefined ? "" : city,
          State: state == undefined ? "" : state,
          WhatIsSpecialty: this.WhatIsSpecialty[i] == 0 || this.WhatIsSpecialty[i] == undefined ? "" : this.WhatIsSpecialty[i],
          WhatDepartmentdoyouworkin: this.WhatDepartmentdoyouworkin[i] == 0 || this.WhatDepartmentdoyouworkin[i] == undefined ? "" : this.WhatDepartmentdoyouworkin[i],
          HowLongYouWorkInDepartment: currentryyear + " " + currentrymonth,
          AreYouManagerInDepartment: this.selecteddepartment[i] == undefined ? "" : this.selecteddepartment[i]
        }
        this.employement.push(tmpdata);
      }
    }

    var precepted = "";
    if (this.precepted == "Yes") {
      precepted = this.preceptedyes;
    } else {
      precepted = this.precepted;
    }
    var acutecareyear = this.AcutecareYear == undefined ? "" : this.AcutecareYear;
    var acutecaremonth = this.AcutecareMonth == undefined ? "" : this.AcutecareMonth;
    var graduateddateyear = this.GraduationDateYear == undefined ? "" : this.GraduationDateYear;
    var graduateddatemonth = this.GraduationDateMonth == undefined ? "" : this.GraduationDateMonth;

    const saveParams = {
      FirstName: data.FirstName == null || data.FirstName == undefined ? "" : data.FirstName,
      LastName: data.LastName == null || data.LastName == undefined ? "" : data.LastName,
      MaidenName: data.MaidenName == null || data.MaidenName == undefined ? "" : data.MaidenName,
      EmailAddress: data.EmailAddress == null || data.EmailAddress == undefined ? "" : data.EmailAddress,
      GraduatedDated: graduateddatemonth + '-01-' + graduateddateyear + ' 00:00:00.000',
      AlumniDegreeId: this.wcuDegree.AlumniDegreeId.toString() == null || this.wcuDegree.AlumniDegreeId.toString() == undefined ? "" : this.wcuDegree.AlumniDegreeId.toString(),
      Degree: this.wcuDegree.AlumniDescription.toString() == null || this.wcuDegree.AlumniDescription.toString() == undefined ? "" : this.wcuDegree.AlumniDescription.toString(),
      Campusgraduatedfrom: this.Campus.Alumni_CampusID.toString() == null || this.Campus.Alumni_CampusID.toString() == undefined ? "" : this.Campus.Alumni_CampusID.toString(),
      CampusgraduatedfromValue: this.Campus.Alumni_CampusDescription.toString() == null || this.Campus.Alumni_CampusDescription.toString() == undefined ? "" : this.Campus.Alumni_CampusDescription.toString(),
      precepted: precepted == null || precepted == undefined ? "" : precepted,
      training_certification: this.training_certification == null || this.training_certification == undefined ? "" : this.training_certification,
      HaveYouObtainedClearanceFromYourSupervisorToPrecept: this.HaveYouObtainedClearanceFromYourSupervisorToPrecept == null ||
        this.HaveYouObtainedClearanceFromYourSupervisorToPrecept == undefined ?  "" : this.HaveYouObtainedClearanceFromYourSupervisorToPrecept,
      Acutecare: acutecareyear + " " + acutecaremonth,
      AlumniID: this.AlumniID,
      EmployementList: this.employement == null || this.employement == undefined ? [] : this.employement,
    }

    this.saveAlumniDetaisService.SaveAlumniDetails(saveParams).subscribe((result) => {
      if (result.ServiceStatus === 'SUCCESS') {
        this.alertService.setAlert(this.alertService.TYPE.SUCCESS, result.Message);
        this.router.navigate(['/thank-you']);
      } else {
        this.alertService.setAlert(this.alertService.TYPE.DANGER, result.Message);
      }
    }, err => {
      this.alertService.setAlert(this.alertService.TYPE.DANGER, 'FAIL');
    });
  }


}
